import SitemapService from '../runtime/services/SitemapService';
import { useSitemapStore } from '../runtime/stores/sitemap';

const store = useSitemapStore();
const { $sitemap } = useSitemap();
const { $t } = useLocalization();

export default defineNuxtRouteMiddleware(async (to, from) =>
{
    if (!store.updated)
    {
        await updateSitemap();
        store.updated = true;
    }
});

async function updateSitemap()
{
    const response = await SitemapService.getSitemap();
    const root = await $sitemap.find({ name: 'studio-docs' });
    const children = response.map((m) =>
    {
        let module: SitemapNode = {
            name: m.name,
            icon: `far fa-fw ${m.icon}`,
            auth: { any: [], all: [] },
            visible: !m.isHidden,
            allowed: true,
            parent: root
        };

        const sections: SitemapNode[] = m.nodes.filter(sectionNode => !sectionNode.isHidden).map((s, i) =>
        {
            const section: SitemapNode = {
                name: s.name,
                route: 'studio-docs-main',
                routeParams: {
                    module: m.symbol,
                    section: s.symbol
                },
                icon: `far fa-fw ${s.icon}`,
                auth: { any: [], all: [] },
                visible: !s.isHidden,
                allowed: true,
                parent: module,
                children: [],
                virtual: true
            };

            if (s.template != 'Settings')
            {
                section.children = [
                    {
                        name: $t('[[[Dodaj wpis]]]'),
                        route: 'studio-docs-add',
                        routeParams: {
                            module: m.symbol,
                            section: s.symbol
                        },
                        auth: { any: [], all: [] },
                        visible: false,
                        allowed: true,
                        parent: section,
                        children: [],
                        virtual: true
                    },
                    {
                        name: $t('[[[Edytuj wpis]]]'),
                        route: 'studio-docs-edit',
                        routeParams: {
                            module: m.symbol,
                            section: s.symbol
                        },
                        auth: { any: [], all: [] },
                        visible: false,
                        allowed: true,
                        parent: section,
                        children: [],
                        virtual: true
                    }
                ];
            }

            return section;
        });

        if (sections.length == 1)
        {
            module = { ...sections[0], ...module };
        }
        else
        {
            module.children = sections;
        }

        return module;
    });

    root.children = root.children || [];

    const virtualModules = root.children.filter(n => n.virtual == true);

    for (const module of virtualModules)
    {
        root.children.remove(p => p == module);
    }

    root.children = [...root.children, ...children];
}
